import { useMutation } from "@tanstack/react-query";
import { useTheme } from "@mui/material/styles";
import { useNotificationService } from "../notification";
import ModalContainer from "../UIElements/modal-container";
import { Box, Button, Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { getUrlPathId } from "../../utils/url-id";
import { useLocation } from "react-router-dom";
import { apiDeleteJob } from "../../api/job";

export const DeleteJob = ({
  open,
  modalHandler,
}: {
  open: boolean;
  modalHandler: () => void;
}) => {
  const theme = useTheme();
  const { showNotification } = useNotificationService();
  const location = useLocation();

  const mutation = useMutation({
    mutationFn: (jobId: string) => apiDeleteJob({ jobId }),
    onSuccess: (data) => {
      if (data?.status === "error") {
        return;
      }
      if ("data" in data) {
        showNotification(data?.data?.message ?? "Success");
        modalHandler();
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });

  const handleDeleteUser = () => {
    const jobId = getUrlPathId(location?.pathname);
    mutation.mutate(jobId);
  };

  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", padding: 3, borderRadius: "16px" }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Outfit",
            fontWeight: 500,
            color: "#292925",
          }}
        >
          Suspend Users
        </Typography>

        <Typography variant="body1" color={"black"} sx={{ my: 2 }}>
          Are you sure you want to delete this job?
        </Typography>

        <Stack
          direction={"row"}
          justifyContent={"space-around"}
          sx={{ gap: 3 }}
        >
          <Button
            onClick={modalHandler}
            sx={{
              width: 150,
              fontWeight: 700,
              borderRadius: "12px",
              background: theme.palette.lightBlue.light,
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <LoadingButton
            onClick={handleDeleteUser}
            color="error"
            loading={mutation.isPending}
            sx={{
              width: 170,
              borderRadius: "12px",
              fontWeight: 700,

              color: "white",
            }}
            variant="contained"
          >
            Delete
          </LoadingButton>
        </Stack>
      </Box>
    </ModalContainer>
  );
};
